import React, { useState } from 'react'
import { UserInfo } from '../../api/dots/getUserInfo'
// tslint:disable-next-line no-submodule-imports
import {
  Page,
  Document,
  Text,
  Image,
  StyleSheet,
  View,
} from '@react-pdf/renderer'
import moment from 'moment'
import { GetLogFromTrackingNumberResponse } from '../../api/dots/getLogFromTrackingNumber'
import { FullTitle, SectionalTitle } from '../../api/Spider'

type OwnerType = 'consumer' | 'company' | 'trust'

type PropertyType = 'sectional' | 'full'

const tableTitleBackground = '#0078a4'
const rowAndCellPadding = 3
const tableHeaderBackground = '#79b4c9'
const border = '1px solid lightgrey'

const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: 'Helvetica',
    flex: 1,
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
  },
  logo: {
    width: 120,
    height: 61,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    marginBottom: 20,
    border,
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  headeTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  headerSubTitle: {
    fontSize: 12,
    textAlign: 'center',
  },
  innerContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    marginTop: 10,
    width: 300,
  },
  innerSection1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  innerSection2: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  label: {
    fontSize: 12,
    fontWeight: 'black',
  },
  erfEnquiry: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    width: 580,
    border,
    marginBottom: 10,
  },
  selectedProperty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    width: 580,
    marginBottom: 10,
    border,
  },
  propertyTitleCell: {
    padding: rowAndCellPadding,
    backgroundColor: 'grey',
    color: 'white',
    border,
  },
  propertyTitleRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    width: 580,
    padding: rowAndCellPadding,
    border,
    backgroundColor: tableTitleBackground,
  },
  propertyRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    width: 580,
  },
  propertyRowHeader: {
    padding: rowAndCellPadding,
    backgroundColor: tableHeaderBackground,
    flex: 0.5,
    border,
  },
  propertyRowCell: {
    padding: rowAndCellPadding,
    flex: 1,
    border,
  },
  propertyTitle: {
    fontSize: 14,
  },
})

type Property = FullTitle | SectionalTitle

type DotsReportProps = {
  sectionalTitles: SectionalTitle[]
  fullTitles: FullTitle[]
  requestedDate: string
  ownerType: OwnerType
  companyName?: string
  registrationNo?: string
  trustName?: string
  trustNo?: string
  ownerName?: string
  userInfo: UserInfo | undefined
} & (
  | {
      propertyType: 'full'
    }
  | {
      propertyType: 'sectional'
    }
)

export const NationalDeedsReport = (props: DotsReportProps) => {
  const {
    fullTitles,
    sectionalTitles,
    ownerType,
    propertyType,
    companyName,
    registrationNo,
    trustName,
    trustNo,
    ownerName,
    userInfo,
  } = props

  const imgUrl = require('../../assets/1000.png')

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image source={imgUrl} style={styles.logo} />
          <View style={styles.headerContent}>
            <Text style={styles.headeTitle}>CMA Info - Calremont</Text>
            <Text style={styles.headerSubTitle}>
              {userInfo?.firstName || ''} {userInfo?.surname || ''}
            </Text>
            <View style={styles.innerContent}>
              <View style={styles.innerSection1}>
                <View style={styles.row}>
                  <Text style={styles.label}>Email: </Text>
                  <Text>{userInfo?.email}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Cell: </Text>
                  <Text>{userInfo?.cell}</Text>
                </View>
              </View>
              <View style={styles.innerSection2}>
                {userInfo?.telephone && (
                  <View style={styles.row}>
                    <Text style={styles.label}>Tel: </Text>
                    <Text>{userInfo?.telephone}</Text>
                  </View>
                )}
                {userInfo?.fax && (
                  <View style={styles.row}>
                    <Text style={styles.label}>Fax: </Text>
                    <Text>{userInfo?.fax}</Text>
                  </View>
                )}
              </View>
            </View>
          </View>
          <Image source={imgUrl} style={styles.logo} />
        </View>
        <View style={styles.selectedProperty}>
          <View style={styles.propertyTitleRow}>
            <Text>Full Title Properties</Text>
          </View>

          <FullTitleRowHeaders ownerType={ownerType} />

          {fullTitles.length === 0 && (
            <View style={styles.propertyRow}>
              <Text>No properties found</Text>
            </View>
          )}

          {fullTitles.map((property: FullTitle) => (
            <FullTitleValues
              property={property}
              companyName={companyName}
              registrationNo={registrationNo}
              trustName={trustName}
              trustNo={trustNo}
              ownerName={ownerName}
            />
          ))}
        </View>
        <View style={styles.selectedProperty}>
          <View style={styles.propertyTitleRow}>
            <Text>Sectional Title Properties</Text>
          </View>
          <SectionalTitleRowHeaders ownerType={ownerType} />
          {sectionalTitles.length === 0 && (
            <View style={styles.propertyRow}>
              <Text>No properties found</Text>
            </View>
          )}
          {sectionalTitles.map((property: SectionalTitle) => (
            <SectionalTitleValues
              property={property}
              companyName={companyName}
              registrationNo={registrationNo}
              trustName={trustName}
              trustNo={trustNo}
              ownerName={ownerName}
            />
          ))}
        </View>
      </Page>
    </Document>
  )
}

type RowHeadersProps = {
  ownerType: OwnerType
}

const FullTitleRowHeaders = (props: RowHeadersProps) => {
  const { ownerType } = props
  return (
    <Row>
      {ownerType === 'consumer' && <RowHeader>Owner</RowHeader>}
      {ownerType === 'company' && <RowHeader>Company Name</RowHeader>}
      {ownerType === 'company' && <RowHeader>Registration #</RowHeader>}
      {ownerType === 'trust' && <RowHeader>Trust #</RowHeader>}
      {ownerType === 'trust' && <RowHeader>Trust Name</RowHeader>}
      <RowHeader>Erf #</RowHeader>
      <RowHeader>Sreet #</RowHeader>
      <RowHeader>Address</RowHeader>
      <RowHeader>Suburb</RowHeader>
      <RowHeader>Municipality</RowHeader>
      <RowHeader>Deeds Office</RowHeader>
    </Row>
  )
}
const SectionalTitleRowHeaders = (props: RowHeadersProps) => {
  const { ownerType } = props
  return (
    <Row>
      {ownerType === 'consumer' && <RowHeader>Owner</RowHeader>}
      {ownerType === 'company' && <RowHeader>Company Name</RowHeader>}
      {ownerType === 'company' && <RowHeader>Registration #</RowHeader>}
      {ownerType === 'trust' && <RowHeader>Trust #</RowHeader>}
      {ownerType === 'trust' && <RowHeader>Trust Name</RowHeader>}
      <RowHeader>Section #</RowHeader>
      <RowHeader>Scheme #</RowHeader>
      <RowHeader>Scheme Name</RowHeader>
      <RowHeader>Address</RowHeader>
      <RowHeader>Suburb</RowHeader>
      <RowHeader>Municipality</RowHeader>
      <RowHeader>Deeds Office</RowHeader>
    </Row>
  )
}

type FullTitleValuesProps = {
  property: FullTitle
} & ValuesProps

type ValuesProps = {
  ownerName?: string
  companyName?: string
  registrationNo?: string
  trustName?: string
  trustNo?: string
}

const FullTitleValues = (props: FullTitleValuesProps) => {
  const {
    property,
    companyName,
    registrationNo,
    trustName,
    trustNo,
    ownerName,
  } = props

  return (
    <Row>
      {registrationNo ? <Cell>{registrationNo}</Cell> : null}
      {trustNo ? <Cell>{trustNo}</Cell> : null}
      <Cell>{property.owner}</Cell>
      <Cell>{property.erfNo}</Cell>
      <Cell>{property.streetNo}</Cell>
      <Cell>{property.address}</Cell>
      <Cell>{property.suburb}</Cell>
      <Cell>{property.municipality}</Cell>
      <Cell>{property.deedsOffice}</Cell>
    </Row>
  )
}

type SectionalTitleValuesProps = {
  property: SectionalTitle
} & ValuesProps
const SectionalTitleValues = (props: SectionalTitleValuesProps) => {
  const {
    property,
    companyName,
    registrationNo,
    trustName,
    trustNo,
    ownerName,
  } = props

  return (
    <Row>
      {registrationNo ? <Cell>{registrationNo}</Cell> : null}
      {trustNo ? <Cell>{trustNo}</Cell> : null}
      <Cell>{property.owner}</Cell>
      <Cell>{property.sectionNo}</Cell>
      <Cell>{property.schemeNo}</Cell>
      <Cell>{property.schemeName}</Cell>
      <Cell>{property.address}</Cell>
      <Cell>{property.suburb}</Cell>
      <Cell>{property.Municipality}</Cell>
      <Cell>{property.deedsOffice}</Cell>
    </Row>
  )
}

const RowHeader = (props: { children: React.ReactNode }) => {
  return (
    <View style={styles.propertyRowHeader}>
      <Text>{props.children}</Text>
    </View>
  )
}

const Row = (props: { children: React.ReactNode }) => {
  return <View style={styles.propertyRow}>{props.children}</View>
}

const Cell = (props: { children: React.ReactNode }) => {
  return (
    <View style={styles.propertyRowCell}>
      <Text>{props.children}</Text>
    </View>
  )
}
